import React from "react";
import type { PDPImage } from "@shared/graphql.types";
import Image from "next/image";
import * as styles from "./Badge.css";

export type Props = {
  badge: PDPImage;
};

export const Badge: React.FC<Props> = ({ badge }) => {
  return (
    <div data-testId="badge-wrapper" className={styles.badgeWrapper}>
      <Image
        className={styles.badge}
        data-testid="pdp-gallery-badge-image"
        src={badge.src ?? ""}
        fill
        alt={badge?.alt ?? ""}
        sizes="(max-width: 768px) 3.4rem, (max-width: 1200px) 6.25rem"
      />
    </div>
  );
};
